export const OWNER_ACTION_PERMISSION = {
  READ: 'ReadOwner',
  UPDATE: 'UpdateOwner',
  DELETE: 'DeleteOwner',
};

export const ACTION_PERMISSION = {
  CREATE: 'Create',
  READ: ['Read', OWNER_ACTION_PERMISSION.READ],
  UPDATE: ['Update', OWNER_ACTION_PERMISSION.UPDATE],
  DELETE: ['Delete', OWNER_ACTION_PERMISSION.DELETE],
  EXPORT: 'Export',
  IMPORT: 'Import',
  IN_BULK: 'In Bulk',
};

export const MODULE_CODE_PERMISSION = {
  MERCHANT_MANAGEMENT: {
    Subsidy_OP_Merchant: 'Subsidy.OP_Merchant',
    Subsidy_OP_SubMerchant: 'Subsidy.OP_SubMerchant',
    Subsidy_OP_SubMerchantManageSupervisorPIN:
      'Subsidy.OP_SubMerchantManageSupervisorPIN',
  },
  ASSET_MANAGEMENT: {
    Subsidy_OP_Asset: 'Subsidy.OP_Asset',
  },
  WORK_ORDER_MANAGEMENT: {
    WORK_ORDER: {
      Subsidy_OP_WorkOrder: 'Subsidy.OP_WO',
      Subsidy_OP_WorkOrderSummary: 'Subsidy.OP_WO_Summary',
      Subsidy_OP_DeployWorkOrderDeployCompletion: 'Subsidy.OP_WO_DSC',
      Subsidy_OP_ServiceMaintenanceRequestType:
        'Subsidy.OP_WO_ServiceMaintenanceRequestType',

      Subsidy_OP_WorkOrderCancelButton: 'Subsidy.OP_WO_CancelButton',
      Subsidy_OP_WorkOrderCompletion_CompleteButton:
        'Subsidy.OP_WO_DSC_CompleteButton',
      Subsidy_OP_WorkOrderCompletion_CloseButton:
        'Subsidy.OP_WO_DSC_CloseButton',
    },
  },
  USER_ACCESS_MANAGEMENT: {
    USER: {
      Subsidy_OP_User: 'Subsidy.OP_User',
      Subsidy_OP_UserResetPassword: 'Subsidy.OP_UserResetPassword',
    },
    USER_GROUP: {
      Subsidy_OP_UserGroup: 'Subsidy.OP_UserGroup',
    },
    ROLE: {
      Subsidy_OP_UserRole: 'Subsidy.OP_UserRole',
    },
  },
  SETTINGS_TENANT_LEVEL: {
    Subsidy_OP_GeneralSettings: 'Subsidy.OP_GeneralSettings',
    Subsidy_OP_AuditTrail: 'Subsidy.OP_AuditTrail',
    Subsidy_OP_EventLog: 'Subsidy.OP_EventLog',
  },

  REPORTING: {
    Subsidy_OP_Reporting: 'Subsidy.OP_Reporting',
  },

  SPECIAL_ACCESS: {
    Subsidy_OP_SPECIAL_ACCESS: 'Subsidy.OP_SpecialAccess',
  },
};
